import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthService } from '@/shared/services';

@Component({
  selector: 'navigation-support-content',
  templateUrl: './navigation-support-content.component.html',
  styleUrls: ['./navigation-support-content.component.css'],
  standalone: false,
})
export class NavigateSupportContentComponent implements OnInit {
  public env = environment;
  public financialaid!: HTMLElement;
  public enrollmentretention!: HTMLElement;

  constructor(public auth: AuthService) {}

  ngOnInit(): void {}

  scroll(el: HTMLElement): void {
    el.scrollIntoView({ behavior: 'smooth' });
  }
}
